<template>
    <div class="mt-6 -mb-1 flex flex-wrap" v-if="showPaginator">
        <nav class="px-4 mt-5 float-right">
            <ul class="pagination">
                <li v-for="(link, key) in links" class="page-item">

                    <inertia-link v-if="link.label === 'Previous' && link.url" :key="key" class="page-link font-poppins color-blue" :href="link.url ? link.url : ''">
                        <span aria-hidden="true">&laquo;</span>
                    </inertia-link>
                    <inertia-link v-if="link.label !== 'Previous' && link.label !== 'Next' && !link.active" :key="key" class="page-link font-poppins color-blue" :class="{'d-none d-lg-block': link.label > 0 || link.label === '...' }" :href="link.url ? link.url : ''">
                        {{ link.label }}
                    </inertia-link>
                    <inertia-link v-if="link.label !== 'Previous' && link.label !== 'Next' && link.active" :key="key" class="page-link font-poppins color-blue active" :class="'active'" :href="link.url ? link.url : ''">
                        {{ link.label }}
                    </inertia-link>
                    <inertia-link v-if="link.label === 'Next' && link.url" :key="key" class="page-link font-poppins color-blue" :href="link.url ? link.url : ''">
                        <span aria-hidden="true">&raquo;</span>
                    </inertia-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        links: Array,
    },
    data() {
        return {
            showPaginator: this.links.filter(item => item.url).length > 1,
        }
    },
}
</script>
